import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import useUpdateProjectPermissionsMutation from '@projects/queries/useUpdateProjectPermissionsMutation';
import { useCallback } from 'react';
import { trackPastCommentsPermissionsChanged } from 'src/services/tracker/trackers/projects';

type UseUpdateCommentsAreHiddenForReviewersParams = {
	projectID: number;
};

const useUpdateCommentsAreHiddenForReviewers = ( { projectID }: UseUpdateCommentsAreHiddenForReviewersParams ) => {
	const snackbarSystem = useSnackbarSystem();

	const { mutate: updateProjectPermissions } = useUpdateProjectPermissionsMutation( { projectID } );

	const updateCommentsAreHiddenForReviewers = useCallback( ( commentsAreHidden: boolean ) => (
		updateProjectPermissions(
			{ see_past_comments_enabled_for_reviewers: !commentsAreHidden },
			{
				onSuccess: ( _, { see_past_comments_enabled_for_reviewers } ) => {
					trackPastCommentsPermissionsChanged( {
						projectID,
						reviewerPastCommentsEnabled: see_past_comments_enabled_for_reviewers
					} );

					snackbarSystem.showSuccessMessage( {
						title: see_past_comments_enabled_for_reviewers
							? 'Comments are visible to all roles'
							: 'Past rounds comments are now hidden for Reviewer roles'
					} );
				}
			}
		)
	), [ updateProjectPermissions, snackbarSystem, projectID ] );

	return updateCommentsAreHiddenForReviewers;
};

export default useUpdateCommentsAreHiddenForReviewers;
